module.exports = __webpack_public_path__ + "static/media/flickr.697c9bc1.svg";